import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloud2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCloud2"><Path d="M10 4C11.752 4 13.3112 4.82042 14.3184 6.09668C14.619 6.0334 14.9306 6 15.25 6C17.7353 6 19.75 8.01472 19.75 10.5C19.75 10.6167 19.7431 10.7322 19.7344 10.8467C21.3586 11.5257 22.5 13.1295 22.5 15C22.5 17.4853 20.4853 19.5 18 19.5H7C3.96243 19.5 1.5 17.0376 1.5 14C1.5 11.8566 2.72652 10.0003 4.51562 9.09277C4.72405 6.2454 7.09942 4 10 4Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconCloud2;
